import {
  Box,
  MenuItem,
  OutlinedInput,
  Select,
  styled,
  Typography,
} from "@mui/material";
import { useIsMobile } from "../../hook/useIsMobile";
import { Close } from "@mui/icons-material";

const NOTE_TYPE_OPTIONS = [
  { value: "", label: "Scegli tipologia", isPlaceholder: true },
  { value: "SIMPLE_NOTE", label: "Nota" },
  { value: "DISEASE_REPORT", label: "Segnalazione malattia" },
];

const StyledInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})(({ theme, isMobile }) => ({
  borderRadius: theme.shape.borderRadius * 5,
  backgroundColor: "#E9EEF0",
  height: 40,
  width: isMobile ? "100%" : 181,
  fontSize: "12px",
  "& .MuiOutlinedInput-notchedOutline": {
    border: "none",
  },
}));

const FieldNotesSelect = ({ value, onChange }) => {
  const isMobile = useIsMobile();

  const selectedOption = NOTE_TYPE_OPTIONS.find((opt) => opt.value === value);

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <Box display="flex" gap={1} alignItems="center">
      <Typography fontSize="12px" color="#616161">
        Mostra
      </Typography>
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        aria-label="Seleziona tipologia nota"
        input={
          <StyledInput
            isMobile={isMobile}
            endAdornment={
              value && (
                <Close
                  sx={{
                    fontSize: "18px",
                    color: "#616161",
                    cursor: "pointer",
                    mr: 2,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange("");
                  }}
                />
              )
            }
          />
        }
        renderValue={() => (
          <span
            style={{
              color: selectedOption?.isPlaceholder ? "#616161" : "inherit",
            }}
          >
            {selectedOption?.label}
          </span>
        )}
      >
        {NOTE_TYPE_OPTIONS.map(({ value, label, isPlaceholder }) => (
          <MenuItem key={value} value={value} disabled={isPlaceholder}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default FieldNotesSelect;
